import styled from 'react-emotion';

export const Text = styled(`p`)`
  margin: 0;
  font-size: ${props => (props.size ? `${props.size}px` : '13px')};
  font-weight: ${props => (props.bold ? 'bold' : 'normal')};
  ${props => (props.color ? `color: ${props.color};` : null)};
  ${props => (props.underline ? `text-decoration: underline;` : null)};
`;
